import { getAuth } from 'firebase/auth';

import {
    client,
    firebaseApp,
    getSubject,
    logout,
    useData,
    useSubject,
} from '@workspace/ui';

export const auth = getAuth(firebaseApp);

export async function getIdentity() {
  const subject = await getSubject(auth);
  if (!subject) {
    return null;
  }
  return client.request('GET /admin/me', {}).catch(async (error) => {
    await logout(auth).catch(() => undefined);
    console.error(error);
    return null;
  });
}

export function useUser() {
  const subject = useSubject(auth);
  return useData(
    'GET /admin/me',
    {},
    { enabled: !!subject?.uid, staleTime: Infinity },
  );
}
